export enum SessionWarningStatus {
  NOT_DISPLAYED = 'NOT_DISPLAYED',
  WARNING = 'WARNING',
  END_OF_SESSION = 'END_OF_SESSION',
}
